import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API, SCOPE_CRM_NOTES } from '../../constants';
import { application } from '../../services/application';
import { getFilterParams } from '../../utils/filterUtils';
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common';
import { extendListBuilder, generateListActions } from '../helpers/listActionsHelpers';
import { extendBuilderWithFacetCounts, extendBuilderWithListControls } from '../helpers/sharedCases';

export const NOTE_FIELD_FILTER_KEYS = ['eventType', 'crmContactId', 'eventDate'];

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['eventDate', 'desc'],
  params: {},
  savePending: false,
  selectedNote: null,
  notePending: false,
  facetCounts: null,
  facetCountsPending: false,
  facetCountsRequestId: null,
};

const listActions = generateListActions({
  scope: SCOPE_CRM_NOTES,
  apiMethod: {
    GET_LIST: API.CRM_NOTES.GET_LIST,
  },
  getStore: (store) => store.crmNotes,
});

export const clearSelectedNote = createAction(`${SCOPE_CRM_NOTES}/clearSelectedNote`);
export const setNoteListFilters = createAction(`${SCOPE_CRM_NOTES}/setNoteListFilters`);
export const setNoteListOrder = createAction(`${SCOPE_CRM_NOTES}/setNoteListOrder`);

export const fetchNote = createAsyncThunk(`${SCOPE_CRM_NOTES}/fetchNote`, (params) => {
  return application.call(API.CRM_NOTES.FIND_ONE, params);
});

export const createNote = createAsyncThunk(`${SCOPE_CRM_NOTES}/createNote`, (params) => {
  return application.call(API.CRM_NOTES.CREATE, params);
});

export const fetchFacetCounts = createAsyncThunk(`${SCOPE_CRM_NOTES}/fetchFacetCounts`, (_, { getState }) => {
  const { text, fields } = getState().crmNotes.filters;

  return application.call(API.CRM_NOTES.GET_FACET_COUNTS, {
    text: text || '',
    filters: getFilterParams(fields),
  });
});

export const actions = {
  ...listActions,
  clearSelectedNote,
  setNoteListFilters,
  setNoteListOrder,
  fetchNote,
  createNote,
  fetchFacetCounts,
};

export default createReducer(INITIAL_STATE, (builder) => {
  extendListBuilder(builder, actions);
  extendBuilderWithListControls(
    builder,
    { setFilters: setNoteListFilters, setOrder: setNoteListOrder },
    NOTE_FIELD_FILTER_KEYS
  );
  extendBuilderWithFacetCounts(builder, fetchFacetCounts);

  builder
    .addCase(fetchNote.pending, (state) => {
      state.notePending = true;
    })
    .addCase(fetchNote.fulfilled, (state, action) => {
      state.selectedNote = action.payload;
      state.notePending = false;
    })
    .addCase(fetchNote.rejected, (state) => {
      state.selectedNote = null;
      state.notePending = false;
    })
    .addCase(createNote.pending, (state) => {
      state.savePending = true;
    })
    .addCase(createNote.fulfilled, (state) => {
      state.savePending = false;
    })
    .addCase(createNote.rejected, (state) => {
      state.savePending = false;
    })
    .addCase(clearSelectedNote, (state) => {
      state.selectedNote = null;
      state.notePending = false;
    });
});
